import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import {
  NotificationCreateTemplate,
  NotificationWizard,
  useNotificationWizard,
} from '@/features/notification';

export const Route = createFileRoute('/_authenticated/notification/create/')({
  component: NotificationCreatePage,
});

function NotificationCreatePage() {
  const { reset } = useNotificationWizard();

  useEffect(() => {
    return () => reset();
  }, [reset]);

  return (
    <NotificationCreateTemplate>
      <NotificationWizard />
    </NotificationCreateTemplate>
  );
}
